import * as React from 'react';

export default () => {
    const [externalWindow, setExternalWindow] = React.useState<Window | undefined>(undefined);

    React.useEffect(() => {
        return () => {
            if (externalWindow) {
                externalWindow.close();
            }
        };
    }, [externalWindow]);

    return { externalWindow, setExternalWindow };
};
